export default "__VITE_ASSET__B2g5QEgL__"